import _ from "lodash";
import React from "react";

const Component = props => {
  const { mainpost, children } = props;
  const { link } = mainpost;
  const slice = link && link.slice(-1) === "/" ? "" : "/";
  const img_src = `${link}${slice}media/?size=l`;
  const src = `http://www.paredesdoporto.com:4043/insta-proxy/${encodeURIComponent(
    img_src
  )}`;
  return (
    <React.Fragment>
      <img className="form-pict" src={src} alt="" />
      {children}
    </React.Fragment>
  );
};
export default Component;
